var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"step-subscription"}},[_c('lz-subscription'),_c('div',{staticClass:"step-subscription__actions"},[_vm._t("actions")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }